import { Component, OnInit, ViewChild } from '@angular/core';
import { EpbtFaQuickPurchaseService } from '../../services/epbt-fa-quick-purchase.service';
import { FieldAgentClient, QuickPurchaseLine, QuantityFromTallyRequest, QuantityFromTallyResponse, IQuickPurchaseLine, QuickPurchase, ITally, Tally } from 'ep-bt-field-agent-proxy';
import { BistrackConfig, ErrorStatus, LocalStorageSaveTypes, PageNames } from 'ep-bt-controls';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { EpbtFaProductService } from '../../services/epbt-fa-product.service';
import { Location } from '@angular/common';
import { EpButtonStyle } from '@epicor/kinetic';
import { Router } from '@angular/router';
import { EpbtFaQuickPurchaseLineModel } from '../../models/epbt-fa-quick-purchase-line.model';
import { EpbtFaQuickPurchaseSummaryProductsGridComponent } from '../epbt-fa-quick-purchase-summary-products-grid/epbt-fa-quick-purchase-summary-products-grid.component';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-quick-purchase-summary',
  templateUrl: './epbt-fa-quick-purchase-summary.component.html',
  styleUrls: ['./epbt-fa-quick-purchase-summary.component.scss']
})
export class EpbtFaQuickPurchaseSummaryComponent implements OnInit {
  webTrackUser: any;
  bisTrackUserId: number;
  EpButtonStyle = EpButtonStyle;

  @ViewChild(EpbtFaQuickPurchaseSummaryProductsGridComponent, { static: false }) epbtFaQuickPurchaseSummaryProductsGridComponent: EpbtFaQuickPurchaseSummaryProductsGridComponent;

  constructor(private client: FieldAgentClient, private config: BistrackConfig,
    private route: Router, private productService: EpbtFaProductService,
    private faService: EpbtFieldAgentService, public faQuickPurchaseService: EpbtFaQuickPurchaseService,
    private location: Location) { }

  ngOnInit() {
    this.faService.getWebTrackUser((webTrackUser: any) => {
      this.webTrackUser = webTrackUser;
      this.bisTrackUserId = this.webTrackUser.bisTrackUserId;
    });
  }

  purchaseClicked() {
    if (this.faQuickPurchaseService.quickPurchase) {
      let quickPurchaseLineItems: QuickPurchaseLine;
      const lines: QuickPurchaseLine[] = [];

      this.faQuickPurchaseService.selectedProductsForBinding.forEach(quickPrcLine => {
        const iQuickPurchaseLineItems: IQuickPurchaseLine = {
          isTallyLine: quickPrcLine.isTallyLine
        };
        quickPurchaseLineItems = new QuickPurchaseLine(iQuickPurchaseLineItems);
        quickPurchaseLineItems.adding = quickPrcLine.adding;

        quickPurchaseLineItems.product = quickPrcLine.product;
        quickPurchaseLineItems.per = quickPrcLine.per;
        const tally: ITally = {
          tallyString: quickPrcLine.tally.tallyString,
          totalTallyPieces: quickPrcLine.tally.totalTallyPieces,
          totalTallyLength: quickPrcLine.tally.totalTallyLength,
          pairs: quickPrcLine.tally.pairs,
          isPackTally: quickPrcLine.tally.isPackTally
        };
        quickPurchaseLineItems.tally = new Tally(tally);
        quickPurchaseLineItems.lineType = quickPrcLine.lineType;
        quickPurchaseLineItems.quantity = quickPrcLine.quantity;
        quickPurchaseLineItems.quantityTally = quickPrcLine.quantityTally;
        quickPurchaseLineItems.inputPer = quickPrcLine.inputPer;
        quickPurchaseLineItems.lineNumber = quickPrcLine.lineNumber;
        quickPurchaseLineItems.perID = quickPrcLine.inputPer ? quickPrcLine.inputPer.perId : -1;
        lines.push(quickPurchaseLineItems);
      });
      // let linesData = [];
      this.faQuickPurchaseService.quickPurchase.lines = [];
      this.faQuickPurchaseService.quickPurchase.lines = lines;
    }

    const quantityFromTallyRequest: Array<QuantityFromTallyRequest> = [];
    this.faQuickPurchaseService.quickPurchase.lines.forEach(line => {
      if (line.perID != 0 && line.product.inputPer != null) {
        if (line.perID != line.product.inputPer.perId) {
          if (this.productService.shouldTallyProduct(line.product.tallyLengths)) {
            const tallyRequest = new QuantityFromTallyRequest();
            line.perID = line.product.inputPer.perId;
            tallyRequest.lineNumber = line.lineNumber;
            tallyRequest.productID = line.product.productId;
            tallyRequest.quantityTally = line.tally.tallyString;
            tallyRequest.quantityPerID = line.per.perId;
            tallyRequest.thickness = line.product.thickness;
            tallyRequest.width = line.product.width;
            tallyRequest.precision = 4;
            quantityFromTallyRequest.push(tallyRequest);
          }
        }
      }
    });

    if (quantityFromTallyRequest.length > 0) {
      this.client.getQuantitiesFromTallies(quantityFromTallyRequest).subscribe(resQty => {
        if (resQty && resQty.length > 0) {
          this.faQuickPurchaseService.quickPurchase.lines.forEach(line => {
            const result = resQty.find(item => item.lineNumber == line.lineNumber && item.productID == line.product.productId);
            if (result) {
              line.quantity = result.quantity;
            }
          });
        }
        // console.log("BisTrackUserId:" + JSON.stringify(this.bisTrackUserId));
        // console.log("QuickPurchase Submition Data:" + JSON.stringify(this.faQuickPurchaseService.quickPurchase));
        this.client.sendQuickPurchase(this.bisTrackUserId, this.faQuickPurchaseService.quickPurchase).subscribe(res => {
          if (res.error != null) {
            this.faService.displayToastMessage('Warning', 'Purchase Order request was not sent' + res.errorMessage, ErrorStatus.Warning);
          } else {
            this.faQuickPurchaseService.errorMessage = 'Your request has been submitted';
          }
          this.faQuickPurchaseService.quickPurchase = null; // clear object
        });
      });
    } else {
      // console.log("BisTrackUserId:" + JSON.stringify(this.bisTrackUserId));
      // console.log("QuickPurchase Submition Data:" + JSON.stringify(this.faQuickPurchaseService.quickPurchase));
      this.client.sendQuickPurchase(this.bisTrackUserId, this.faQuickPurchaseService.quickPurchase).subscribe(res => {
        if (res.error != null) {
          this.faService.displayToastMessage('Warning', 'Purchase Order request was not sent' + res.errorMessage, ErrorStatus.Warning);
        } else {
          // this.faService.displayToastMessage("Success", "Your request has been submitted", ErrorStatus.Success);
          this.faQuickPurchaseService.errorMessage = 'Your request has been submitted';
        }
        this.faQuickPurchaseService.quickPurchase = null; // clear object
      });
    }
    // console.log("quickPurchase" + JSON.stringify(this.faQuickPurchaseService.quickPurchase));
    // Submit this request to the proper web service.
  }

  doneClicked() {
    if (this.faQuickPurchaseService.fromDashbard) {
      this.route.navigate(['/home']);
    } else {
      if (this.productService.selectedProductItem) {
        localStorage.setItem(LocalStorageSaveTypes.ProIndex, '0');
        this.productService.fromPage = PageNames.ProductSearch;
        this.route.navigate(['/home/product/details/', this.productService.selectedProductItem.productId]);
      } else {
        this.route.navigate(['/home']);
      }
    }
    this.faQuickPurchaseService.clearData();
    // this.faQuickPurchaseService.clearData();
    // this.route.navigate(['/home']);
  }

  updateGridData() {
    this.epbtFaQuickPurchaseSummaryProductsGridComponent.updateGridData();
  }
}
